module.exports = __webpack_public_path__ + "media/images/proof_links/colored/facebook-cf826b0747a1ad309bcf8b0ad668a4cf.svg";